'use client';
import { useTranslations } from 'next-intl';

import ArticlePremiumVideoCover from '../atoms/ArticlePremiumVideoCover';
import ArticleVideoPlayer from '../atoms/ArticleVideoPlayer';

import { getPremiumStatus } from '@utils/getters';
import { useUserStore } from '@utils/user';

export const VideoPlayer = ({
  article,
  isPremiumRequired,
  isLoggedInRequired,
  isNewsletterRequired
}) => {
  const t = useTranslations('main');
  const { isPremium, isLoggedIn, hasNewsletter } = useUserStore();

  if (!getPremiumStatus(article)) {
    return <ArticleVideoPlayer className="mb-4" videoUrl={article.video} />;
  }

  if (isPremiumRequired && !isPremium || isLoggedInRequired && !isLoggedIn || isNewsletterRequired && !hasNewsletter) {
    return (
      <ArticlePremiumVideoCover
        className="mb-4"
        imageSrc={article.featuredImage}
        imageAlt={article.featuredImageCaption}
        videoLockedLabel={t('posts.articleBanner.video')}
      />
    );
  }

  return <ArticleVideoPlayer className="mb-4" videoUrl={article.video} />;
};
